// get employeee list for admin workforce
export const GET_EMPLOYEE_Details = "GET_EMPLOYEE_Details";
export const GET_EMPLOYEE_Details_SUCCESS = "GET_EMPLOYEE_Details_success";
export const GET_EMPLOYEE_Details_FAILURE = "GET_EMPLOYEE_Details_failure";
export const RESET_GET_EMPLOYEE_Details = "RESET_GET_EMPLOYEE_Details";
